import React, { useState, useEffect } from 'react'
import './form.scss'
import {
  Grid,
  FormControl,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
  Button,
} from '@material-ui/core'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useForm } from '../../../context/formContext'
import { createMiForm } from '../../../services/Forms/create'
import ReactTooltip from 'react-tooltip'
import ExitIcon from '@material-ui/icons/ExitToApp'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom'
import { useAuthentication } from '../../../context/authenticationContext'
import Box from '@mui/material/Box'

const Form = () => {
  const { userCountry } = useAuthentication()

  const [labelIdentificator, setLabelIdentificator] = useState(null)
  const [miLoading, setMiLoading] = useState(false)
  const {
    miPymesType,
    setPreEligibilityForm,
    preEligibilityForm,
    listCountries,
    getData,
    globalLoading,
  } = useForm()
  const [selectedCountry, setSelectedCountry] = useState(0)
  const [checkErrors, setCheckErrors] = useState(false)

  const DataSchema = Yup.object().shape({
    idMiPymeType: Yup.number().required('Este campo es obligatorio'),
    businessName: Yup.string().required('Este campo es obligatorio'),
    taxRegistration: Yup.string().required('Este campo es obligatorio'),
  })

  const history = useHistory()

  const formik = useFormik({
    initialValues: {
      businessName: '',
      idMiPymeType: '',
      taxRegistration: '',
    },
    validationSchema: DataSchema,
    onSubmit: (values) => {
      if (!checkErrors) {
        save()
      }
    },
  })

  const validateFormStatus = () => {
    if (!formik.isValid) {
      alertValidationFields()
    }

    if (formik.values.idMiPymeType === 0) {
      setCheckErrors(true)
      alertValidationFields()
    } else {
      setCheckErrors(false)
    }
  }

  const alertValidationFields = () => {
    Swal.fire({
      icon: 'error',
      title: 'Campos obligatorios',
      text: 'Es necesario completar todos los campos del formulario.',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Reintentar',
    })
  }

  const save = () => {
    setMiLoading(true)
    const payload = {
      ...preEligibilityForm,
    }
    createMiForm(payload)
      .then((res) => {
        setMiLoading(false)
        if (res.response.ok) {
          // const mensaje = res.response.mensaje
          Swal.fire({
            icon: 'success',
            title: 'Registrado',
            // text: mensaje,
            confirmButtonColor: '#3085d6',
            allowOutsideClick: false,
            confirmButtonText: 'Entendido',
          }).then(() => {
            history.push('/')
          })
        } else {
          const mensaje = res.response.mensaje
          Swal.fire({
            icon: 'error',
            title: 'No Registrado',
            text: mensaje,
            confirmButtonColor: '#3085d6',
          })
        }
      })
      .catch((err) => {
        console.log(err)
        setMiLoading(false)
      })
  }

  const handleToDashboard = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Entendido',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        setPreEligibilityForm([])
        history.push('/')
      }
    })
  }

  const getPatternMiPymeId = () => {
    if (parseInt(userCountry) !== null) {
      switch (parseInt(userCountry)) {
        case 1:
          return '[\\0-9]{0,15}'
        case 2:
          return '[sa-zA-ZñÑ0-9]{0,15}'
        case 3:
          return '[0-9]{0,15}'
        case 4:
          return '[sa-zA-ZñÑ0-9]{0,15}'
        case 5:
          return '[0-9]{0,15}'
        case 6:
          return '[sa-zA-ZñÑ0-9]{0,17}'
        case 7:
          return '[0-9]{0,15}'
        default:
          return null
      }
    } else {
      return null
    }
  }

  useEffect(() => {
    if (listCountries && listCountries.length > 0) {
      if (selectedCountry !== '') {
        formik.setFieldValue('taxRegistration', '')

        const label = listCountries.filter(
          (item) => item.idCountry === selectedCountry,
        )
        if (label[0] !== undefined) {
          setLabelIdentificator(label[0].labelIdentification.denomination)
        } else {
          setLabelIdentificator('')
        }
      } else {
        formik.setFieldValue('taxRegistration', '')
        setLabelIdentificator(null)
      }
    }
  }, [selectedCountry, listCountries])

  useEffect(() => {
    if (userCountry) {
      setSelectedCountry(parseInt(userCountry))
    }
  }, [userCountry])

  useEffect(() => {
    document.getElementById('transfers-form')[0].click()
    getData()
  }, [])

  return (
    <>
      {globalLoading ? (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      ) : (
        <form id="transfers-form" onSubmit={formik.handleSubmit}>
          <Grid className="miContainer">
            <Grid className="miForm">
              <Grid className="exitGridButton" md={12} sm={12} xs={12}>
                <div
                  data-tip
                  data-for="exitPop"
                  onClick={() => handleToDashboard()}
                  style={{
                    backgroundColor: 'red',
                    color: '#fff',
                    width: '40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '4px',
                    padding: '5px',
                    cursor: 'pointer',
                  }}
                >
                  <ExitIcon style={{ transform: 'scaleX(-1)' }} />
                  <ReactTooltip
                    id="exitPop"
                    effect="solid"
                    backgroundColor="red"
                  >
                    <span>Regresar</span>
                  </ReactTooltip>
                </div>
              </Grid>
              <Grid md={12} sm={12} xs={12} className="miTitle">
                <h1>Registro MIPYME</h1>
                <p>Rellene la información requerida para registrar la MIPYME</p>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="miResponsiveLabel">
                    1. Nombre de la MIPYME
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <TextField
                      id="businessName"
                      style={{ width: '100%' }}
                      error={formik.errors.businessName}
                      variant="outlined"
                      onChange={(e) => {
                        if (e.target.validity.valid) {
                          formik.setFieldValue('businessName', e.target.value)

                          setPreEligibilityForm({
                            ...preEligibilityForm,
                            businessName: e.target.value,
                          })
                        }
                      }}
                      value={formik.values.businessName}
                      inputProps={{
                        maxLength: 64,
                        autoComplete: 'off',
                        pattern: '[\\sa-zA-ZñÑäÄëËïÏöÖüÜáÁéÉíÍóÓúÚ]{0,64}',
                      }}
                    />
                    {formik.errors.businessName ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.businessName}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="miResponsiveLabel">2. Tipo de MIPYME</label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <Select
                      id="idMiPymeType"
                      value={formik.values.idMiPymeType}
                      onChange={(e) => {
                        formik.setFieldValue('idMiPymeType', e.target.value)
                        setPreEligibilityForm({
                          ...preEligibilityForm,
                          idMiPymeType: e.target.value,
                        })
                      }}
                      variant="outlined"
                      error={formik.errors.idMiPymeType}
                    >
                      <MenuItem value={''} disabled>
                        Seleccione una opción
                      </MenuItem>
                      {miPymesType &&
                        miPymesType.map((item, key) => (
                          <MenuItem key={key} value={item.idMiPymeType}>
                            {item.description}
                          </MenuItem>
                        ))}
                    </Select>
                    {formik.errors.idMiPymeType ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.idMiPymeType}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>

              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  <label className="miResponsiveLabel">
                    3. Identificador MIPYME{' '}
                    {labelIdentificator && labelIdentificator}
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <TextField
                      id="taxRegistration"
                      style={{ width: '100%' }}
                      error={formik.errors.taxRegistration}
                      variant="outlined"
                      value={formik.values.taxRegistration}
                      inputProps={{
                        autoComplete: 'off',
                        pattern: getPatternMiPymeId(),
                      }}
                      onChange={(e) => {
                        if (e.target.validity.valid) {
                          formik.setFieldValue(
                            'taxRegistration',
                            e.target.value,
                          )
                          setPreEligibilityForm({
                            ...preEligibilityForm,
                            taxRegistration: e.target.value,
                          })
                        }
                      }}
                    />
                    {formik.errors.taxRegistration ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.taxRegistration}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>
              <Grid xs={12} sm={12} md={12} className="containerButtonNav">
                {/* <Button
                onClick={() => handleToDashboard()}
                className="miButtonRe"
                disabled={miLoading}
              >
                <p>Cancelar</p>
              </Button> */}
                {!miLoading ? (
                  <Button
                    onClick={() => validateFormStatus()}
                    type="submit"
                    variant="contained"
                    className="miButtonRe"
                  >
                    <p>Registrar</p>
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    className="miButtonRe"
                    disabled={true}
                  >
                    <CircularProgress size={23} style={{ color: '#fff' }} />
                  </Button>
                )}
              </Grid>
            </Grid>
          </Grid>
        </form>
      )}
    </>
  )
}

export default Form
